import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class BookingService {
  private apiUrl = `${environment.apiUrl}/booking`;
  constructor(private http: HttpClient) {}

  // Membuat booking baru
  createBooking(bookingData: any): Observable<any> {
    return this.http.post(`/api/booking/create`, bookingData);
  }

  // Mendapatkan riwayat booking berdasarkan ID pelanggan
  getBookingHistory(idPelanggan: number): Observable<any> {
    return this.http.get(`/api/booking/history/${idPelanggan}`);
  }

  // Membatalkan booking
  cancelBooking(cancelData: any): Observable<any> {
    return this.http.post(`/api/booking/cancel`, cancelData);
  }

  // Memperbarui data pelanggan
  updatePelangganData(pelangganData: any): Observable<any> {
    return this.http.put(`/api/booking/updatePelanggan`, pelangganData);
  }

  // // Mendapatkan semua booking (untuk admin)
  getAllBookings(): Observable<any> {
    return this.http.get<any>(`/api/booking/all`);
  }


  getBookingsByEmail(email:string): Observable<any> {
    return this.http.get<any>(`/api/booking/history_email/${email}`);
  }


  getDetailBooking(kode_booking:string): Observable<any> {
    return this.http.get<any>(`/api/booking/detail_booking/${kode_booking}`);
  }


  deleteBookingByCode(kode_booking: string): Observable<any> {
    return this.http.delete<any>(`/api/booking/hapus_booking/${kode_booking}`);
  }


  getPelangganById(id:number): Observable<any> {
    return this.http.get<any>(`/api/pelanggan/${id}`);
  }


   // Memperbarui data pelanggan
  confirmBook(id_booking: number): Observable<any> {
    return this.http.put(`/api/booking/confirmBook`, {id_booking});
  }

  cancelBook(id_booking: number, reason : string): Observable<any> {
    return this.http.put(`/api/booking/cancelBook`, {id_booking, reason});
  }

  updateCheckInTime(kode_booking: string, check_in_at: string | null): Observable<any> {
    return this.http.put(`/api/booking/check-in`, { kode_booking, check_in_at });
  }

  expireBook(id_booking: number): Observable<any> {
    return this.http.post(`/api/booking/expireBook`, {id_booking});
  }


  getInvoiceStatus(kode_booking:string): Observable<any> {
    return this.http.get<any>(`/api/booking/invoice_status/${kode_booking}`);
  }

  getPaymentStatus(kode_booking:string): Observable<any> {
    return this.http.get<any>(`/api/booking/pament_status/${kode_booking}`);
  }

}
